export class ScreeningReport{
    displayName: string;
    jobTitle: string;
    message: string;
    messageClass: string;
    timeLeft: number;
    enteredDateTime: string;
    hoursDisplay: number;
    minutesDisplay: number;
    secondsDisplay: number;
    showCameraFooter: boolean;
    resultType: string;
}